<form #formEl [formGroup]="formGroup" class="left">
  <!-- <wz-health-vad-alert></wz-health-vad-alert> -->

  <wz-form-group [expandable]="true" [expanded]="true" [disabled]="disabled">
    <wz-form-group-header>
      <mat-icon>person</mat-icon>
      Assuré principal
    </wz-form-group-header>

    <wz-health-assure-form
      (regimeSocial)="newRegimeSocial($event)"
      (dateEffet)="newDateEffet($event)"
      [package]="package"
      [formula]="formula"
    >
    </wz-health-assure-form>
  </wz-form-group>

  <wz-form-group [expandable]="true" [expanded]="true" [disabled]="disabled">
    <wz-form-group-header>
      <mat-icon>people</mat-icon>
      Famille de l'assuré
    </wz-form-group-header>

    <wz-health-family-form
      [regimeSocial]="regimeSocial"
      [dateEffet]="dateEffet"
      [package]="package"
      [formula]="formula"
    >
    </wz-health-family-form>
  </wz-form-group>

  <wz-form-group [expandable]="true" [expanded]="true" [disabled]="disabled">
    <wz-form-group-header>
      <mat-icon>people</mat-icon>
      Besoins de l'assuré
    </wz-form-group-header>
  </wz-form-group>
</form>
